
import { uGetDateFormat } from '@appbase/util';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const today: Date = new Date();
const queryStart: Date = new Date();
queryStart.setDate(today.getDate() - 30);

// initial state
const state: survey.state.SurveyState = {
    pageSet: {
        surveyStatus: 2,
        approvalStatus: 3,
        filter: 0,
        startDate: uGetDateFormat('yyyy-MM-dd', queryStart),
        endDate: uGetDateFormat('yyyy-MM-dd', today),
        keyword: '',
        pageNumber: 1,
        rowCount: 15
    },
    permissions : Object.create(null),
    listGrid : Object.create(null),
    createdSurveyId : Object.create(null),
    createdQuestions : [],
    answers : [],
    statisticsDetail : Object.create(null),
    listTotalCount : 0
};

export default {
    state,
    actions,
    getters,
    mutations,
};
